import * as React from 'react';
import AfrDataCore from '../AfrCore/AfrDataCore';

const AfrDataA = (props: any) => {

    return (
        <React.Fragment>
            <AfrDataCore userRole="ENTITY_USER" />
        </React.Fragment>
    );
}

export default AfrDataA;